module.exports = __webpack_public_path__ + "img/inge-v9-1.47f687e5.png";